export default __webpack_public_path__ + "static/media/dt9803.5a36b873.png";